import type { AnchorCategory, PublishDestination, PublishDevice, StepId } from './types';

export const ALL_STEPS: readonly StepId[] = [
  'choose-platform',
  'project-info',
  'scene-info',
  'anchor-info',
  'confirmation',
] as const;

export const TEMPLATE_STEPS: readonly StepId[] = [
  'choose-platform',
  'template-info',
  'template-features',
  'template-media',
  'template-confirm',
] as const;

export const STEP_LABELS: Record<StepId, string> = {
  'choose-platform': 'Destination',
  'project-info': 'Project',
  'scene-info': 'Story',
  'anchor-info': 'Anchor',
  confirmation: 'Confirm',
  'template-info': 'Template',
  'template-features': 'Features',
  'template-media': 'Media',
  'template-confirm': 'Confirm',
};

export interface RoutingInput {
  devices: PublishDevice[];
  anchorCategory: AnchorCategory | undefined;
  destination: PublishDestination;
}

const sceneUsesAnchorInfo = (a: AnchorCategory | undefined): boolean =>
  a === 'immersal' || a === 'image_anchor' || a === 'geospatial_anchor';

// The markers the stepper draws. The audience path renders all five, dimming the
// ones the current device/anchor combination skips; the template path is fixed,
// so it renders only its own five.
export function getPathSteps(destination: PublishDestination): readonly StepId[] {
  return destination === 'template' ? TEMPLATE_STEPS : ALL_STEPS;
}

export function getVisibleSteps({ devices, anchorCategory, destination }: RoutingInput): StepId[] {
  if (destination === 'template') return [...TEMPLATE_STEPS];

  const hasApp = devices.includes('app');
  const hasAppless = devices.includes('appless');
  const usesAnchor = sceneUsesAnchorInfo(anchorCategory);

  const steps: StepId[] = ['choose-platform'];
  if (hasApp) {
    steps.push('project-info', 'scene-info');
  }
  if (usesAnchor && (hasApp || hasAppless)) {
    steps.push('anchor-info');
  }
  steps.push('confirmation');
  return steps;
}
